module.exports = __webpack_public_path__ + "3e524885d0ba50fcbb3d1de1c6e7bcf3.png";